var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", [
        _c(
          "main",
          {
            staticClass: "auth-container main-container can-remove-beacon",
            attrs: { tabindex: "-1", id: "okta-sign-in" }
          },
          [
            _c("div", { staticClass: "okta-sign-in-header auth-header" }, [
              _c("h1", [
                _c("img", {
                  staticClass: "auth-org-logo",
                  attrs: {
                    src: require("./../assets/qrp-abbreviated-color.svg"),
                    alt: "qrp-auth logo logo",
                    "aria-label": "qrp-auth logo logo"
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "beacon-container",
                  staticStyle: {
                    transform: "scale(1, 1)",
                    "text-indent": "1px"
                  },
                  attrs: { "data-type": "beacon-container" }
                },
                [
                  _c("div", { staticClass: "js-security-beacon" }, [
                    _c("div", { staticClass: "beacon-blank" }, [
                      _c(
                        "div",
                        {
                          staticClass: "radial-progress-bar",
                          staticStyle: { clip: "rect(0px, 96px, 96px, 48px)" }
                        },
                        [
                          _c("div", {
                            staticClass: "circle left",
                            staticStyle: {
                              transform: "rotate(0deg)",
                              "text-indent": "1px"
                            }
                          }),
                          _c("div", {
                            staticClass: "circle right",
                            staticStyle: {
                              transform: "rotate(0deg)",
                              "text-indent": "1px"
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "bg-helper  auth-beacon auth-beacon-security displayDefaultImg",
                        attrs: {
                          "aria-live": "polite",
                          role: "img",
                          "data-se": "security-beacon"
                        }
                      },
                      [
                        _c("div", {
                          staticClass:
                            "okta-sign-in-beacon-border js-auth-beacon-border auth-beacon-border"
                        })
                      ]
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "auth-content" }, [
              _c("div", { staticClass: "auth-content-inner" }, [
                _c(
                  "p",
                  {
                    staticClass: "fontForLogin",
                    staticStyle: { "text-align": "center" }
                  },
                  [_vm._v("User is inactive")]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "fontForLogin" }, [
                  _vm._v(
                    "Please contact your administrator or close your browser to sign in as a different user."
                  )
                ])
              ])
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f99a0d88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f99a0d88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/LoggedOut.vue
// module id = null
// module chunks = 